import { getLogger } from '@sas/nova-core/logging';

import {
  TableSummary,
  TableVersion,
} from '../../../sonder/rest/representations/datatables/datatables';

import { DecodePath } from '../rest/api';
import { URIFormatDataSources, URIFormatDataTables } from './api';

// eslint-disable-next-line @sas/i18n/jsx-to-localize
const logger = getLogger('DataSelection');

const pathSegmentRegexString = "([A-Za-z0-9%~\\-\\._!$'\\(\\)\\*+,;:@]+)";

const dataSourcesURIRegex = new RegExp(
  `${URIFormatDataSources.replace(/%s/g, pathSegmentRegexString)}.*$`
);
const dataTablesURIRegex = new RegExp(
  `${URIFormatDataTables.replace(/%s/g, pathSegmentRegexString)}.*$`
);

// 138
// ResolveTableURI populates a TableSummary with information pulled from the given dataTables URI
export const ResolveTableURI = (URI: string): [TableSummary?, Error?] => {
  const parsed = new URL(URI, window.location.href);
  let fileExtension = parsed.searchParams.get('ext');
  if (fileExtension && fileExtension.length > 0) {
    fileExtension = `.${fileExtension}`;
  } else {
    fileExtension = ''; // ensure null/undefined converted to empty string.
  }
  const parameterlessURI = URI.split('?')[0];
  const dtMatch = dataTablesURIRegex.exec(parameterlessURI);
  if (dtMatch === null) {
    logger.debug(`Unable to extract table information from table URI ${parameterlessURI}`);
    return [undefined, Error('invalid or unrecognized table uri')];
  }
  const table: TableSummary = {
    // "/dataTables/dataSources/%s~fs~%s~fs~%s/tables/%s"
    providerId: DecodePath(dtMatch[1]),
    dataSourceId: DecodePath(dtMatch[3]),
    name: DecodePath(dtMatch[4]) + fileExtension,
    attributes: { serverId: DecodePath(dtMatch[2]) },
    version: TableVersion, // from NewTableSummary constructor
  };
  logger.debug(`Successfully extracted table summary info from ${URI}`);
  return [table, undefined];
};

// 166
// ExtractProviderAndServer pulls the server or context and provider from the given dataSources or dataTables URI
export const ExtractProviderAndServer = (
  URI: string
): { provider: string; server: string; err?: Error } => {
  const dsMatch = dataSourcesURIRegex.exec(URI);
  if (dsMatch) {
    logger.debug(`${URI} looks like a dataSources URI`);
    const provider = DecodePath(dsMatch[1]);
    const server = DecodePath(dsMatch[2]);
    return { provider, server };
  }
  const dtMatch = dataTablesURIRegex.exec(URI);
  if (dtMatch) {
    logger.debug(`${URI} looks like a dataTables URI`);
    const provider = DecodePath(dtMatch[1]);
    const server = DecodePath(dtMatch[2]);
    return { provider, server };
  }
  logger.debug(`${URI} looks like neither a dataSources or dataTables URI`);
  return {
    provider: '',
    server: '',
    err: Error('unable to extract provider and server from the given URI'),
  };
};
